import { render, staticRenderFns } from "./MedicalRecords.vue?vue&type=template&id=cd95b9a0&scoped=true&"
import script from "./MedicalRecords.vue?vue&type=script&lang=js&"
export * from "./MedicalRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd95b9a0",
  null
  
)

export default component.exports